import { render, staticRenderFns } from "./m-roster-details.vue?vue&type=template&id=6d5b87d0&scoped=true&"
import script from "./m-roster-details.ts?vue&type=script&lang=ts&"
export * from "./m-roster-details.ts?vue&type=script&lang=ts&"
import style0 from "./m-roster-details.scss?vue&type=style&index=0&id=6d5b87d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5b87d0",
  null
  
)

export default component.exports